import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.scss";
import "normalize.css";
import 'react-confirm-alert/src/react-confirm-alert.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
